import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCorrectIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 19,
	viewBox: "0 0 20 19",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.700 5.319 C 15.624 5.352,14.266 6.686,11.792 9.159 L 8.000 12.950 6.458 11.409 C 5.399 10.351,4.878 9.853,4.793 9.818 C 4.534 9.711,4.186 9.772,3.989 9.960 C 3.759 10.178,3.689 10.553,3.828 10.820 C 3.867 10.896,4.660 11.713,5.756 12.805 C 7.723 14.765,7.697 14.742,8.000 14.742 C 8.313 14.742,8.128 14.914,12.495 10.555 C 15.653 7.403,16.623 6.416,16.675 6.302 C 16.846 5.926,16.672 5.477,16.293 5.318 C 16.137 5.253,15.853 5.254,15.700 5.319 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgCorrectIcon;
